/* 🤖 this file was generated by svg-to-ts */
export const DfIconCameraPlus16: {
  name: 'camera-plus-16';
  data: string;
} = {
  name: 'camera-plus-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M0 8c.836.628 1.874 1 3 1 .343 0 .678-.035 1.001-.1L4 9a4 4 0 1 0 3.9-3.999C7.965 4.678 8 4.343 8 4a4.978 4.978 0 0 0-1-3h3.309a2 2 0 0 1 1.805 1.14L13 4h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM2 3V2a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2H4v1a1 1 0 1 1-2 0V5H1a1 1 0 1 1 0-2z" fill-rule="evenodd"/></svg>`
};
